export class SchemaRegistryResolveSubjectRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "schemaRegistry",
            "baseName": "schemaRegistry",
            "type": "SchemaRegistryConfig",
            "format": ""
        },
        {
            "name": "topics",
            "baseName": "topics",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "subjectNamingStrategy",
            "baseName": "subjectNamingStrategy",
            "type": "SubjectNamingStrategy",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SchemaRegistryResolveSubjectRequest.attributeTypeMap;
    }
    constructor() {
    }
}
